import axios from '../../axios';

const path = '/subscription';
const service = {
  async getPlans() {
    return axios({ method: 'get', url: `${path}/plans` });
  },

  async getUserSubscriptionById(id) {
    return axios({ method: 'get', url: `${path}/user/${id}` });
  },

  async getFeatureOptions() {
    return axios({ method: 'get', url: `${path}/feature-options` });
  },

  async addUserSubscription(data) {
    return axios({ method: 'post', url: `${path}/user`, data });
  },

  async updateUserSubscriptionStatus(data) {
    return axios({ method: 'put', url: `${path}/user/status`, data });
  },

  cancelUserSubscription() {
    return axios({ method: 'delete', url: `${path}/user/my` });
  },

  async getMyPlan() {
    return axios({ method: 'get', url: `${path}/user/my` });
  },

  async activateTrial(data) {
    return axios({ method: 'post', url: `${path}/user/active-trial`, data });
  }
};

export default service;
